import StringField from './string';

export default class BigIntegerField extends StringField {}
